import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import GenericButton from 'src/components/GenericButton';
import ModalLayout, { ModalHeader, ModalTitle as ModalTitleBase, ModalContent as ModalContentBase, ModalFooter as ModalFooterBase, MobileModalType, ModalLayoutProps } from 'src/components/ModalLayout';
import useHelpCenterUrl from 'src/hooks/useHelpCenterUrl';
const ModalTitle = styled(ModalTitleBase)`
  color: ${({
  theme
}) => theme.color.content12};
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
`;
const ModalContent = styled(ModalContentBase)`
  padding: 16px 24px;
`;
const DuplicateMessage = styled.p`
  font-size: 15px;
  line-height: 20px;
  color: ${({
  theme
}) => theme.color.content8};
  text-align: center;
  margin-block-start: 12px;
  white-space: pre-line;
`;
const ModalFooter = styled(ModalFooterBase)`
  padding: 16px 24px 24px;
  background-color: ${({
  theme
}) => theme.color.bg2};
`;
const StyledModalLayout = styled(ModalLayout)`
  min-width: 360px;
  max-width: 360px;
`;
const SubscriptionDuplicateModal = (props: ModalLayoutProps) => {
  const {
    t
  } = useTranslation();
  const customerURL = useHelpCenterUrl();
  const handleContactClick = () => {
    window.open(customerURL, '_blank', 'noopener,noreferrer');
  };
  return <StyledModalLayout {...props} mobileType={MobileModalType.BOTTOM_SHEET} isDim data-sentry-element="StyledModalLayout" data-sentry-component="SubscriptionDuplicateModal" data-sentry-source-file="index.tsx">
      <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="index.tsx">
        <ModalTitle data-sentry-element="ModalTitle" data-sentry-source-file="index.tsx">{t('more.subs_duplicate_title')}</ModalTitle>
      </ModalHeader>
      <ModalContent data-sentry-element="ModalContent" data-sentry-source-file="index.tsx">
        <DuplicateMessage data-sentry-element="DuplicateMessage" data-sentry-source-file="index.tsx">{t('more.subs_duplicate_desc')}</DuplicateMessage>
      </ModalContent>
      <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="index.tsx">
        <GenericButton variant='primary' size='large' onClick={handleContactClick} data-sentry-element="GenericButton" data-sentry-source-file="index.tsx">
          {t('LOGIN__CONTACT_US')}
        </GenericButton>
      </ModalFooter>
    </StyledModalLayout>;
};
export default SubscriptionDuplicateModal;